import { FC } from 'react'

import { ConfigFormTemplate } from 'Automations/nodeDefinitions/components'
import { ConfigFormProps } from '../../types'
import { useNode } from '../../hooks'
import { Config } from '.'

export const EndNodeConfigForm: FC<ConfigFormProps> = ({ nodeId }) => {
  const { nodeData, definition } = useNode<Config>({ nodeId })
  if (!nodeData || !definition) return null

  return (
    <ConfigFormTemplate>
      <ConfigFormTemplate.Header nodeId={nodeId} />
    </ConfigFormTemplate>
  )
}
